<template>
    <div class="c-a-image-upload">
        <p class="c-a-image-upload__title">{{title}}</p>
        <p class="c-a-image-upload__info">{{info}}</p>
        <button v-if="imageSrc" class="c-a-image-upload__wrapper c-a-image-upload__wrapper--with-image" @click="clear" @keyup.space="clear">
            <div class="c-a-image-upload__button"><icon :icon="'close'"></icon>Ta bort bild</div>
            <img class="c-a-image-upload__image" :src="imageSrc" :alt="`Vald bild till ${title}`">
        </button>
        <label v-else class="c-a-image-upload__wrapper c-a-image-upload__wrapper--empty" :for="`file-${name}-${id}`">
            <input type="file" name="newImage" :id="`file-${name}-${id}`" @change="upload" accept="image/png, image/jpeg, image/gif"/>
            <div v-if="loading" class="c-a-image-upload__button"><icon class="c-a-icon--animation-spinner" :icon="'spinner'"></icon></div>
            <div v-else class="c-a-image-upload__button"><icon :icon="'file_upload'"></icon>Ladda upp bild</div>
        </label>
    </div>
    </template>
    
    <script>
    import Icon from '../AtomIcon.vue'
    
    export default{
        props:{
            value: String,
            name: String,
            title: String,
            info: String,
            id: Number
        },
        data() {
            return {
                imageSrc: this.value,
                loading: false
            }
        },
        components:{
            Icon
        },
        methods: {
            clear() {
                this.imageSrc = null;
                this.$emit('input', null);
            },
            upload(event) {
                this.loading = true
                const file = event.target.files[0]
    
                if(file) {
                    this.$emit('input', file);
    
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.loading = false;
                        this.imageSrc = e.target.result;
                    }
                    reader.readAsDataURL(file);
                }
            }
        }
    }
    
    </script>
    


// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomImageUpload.vue